export const timeLesserDirective = (defaultErrorMessageResolver) => {
    'ngInject';

    defaultErrorMessageResolver.getErrorMessages().then((errorMessages) => {
        errorMessages['timeLesser'] = 'End time should be greater than start time';
    });

    return {
        require: '^ngModel',
        restrict: 'A',
        scope: {
            timeLesser: '=',
            ngRequired: '='
        },
        link: (scope, element, attrs, ngModel) => {
            ngModel.$validators.timeLesser = (value) => {
                if(value && scope.ngRequired) {
                    let _time = value;
                    let _timeLesser = scope.timeLesser;
                    if(_time <= _timeLesser) {
                        return false;
                    }
                }
                return true;
            };
            scope.$watch('timeLesser', (value) => {
                if(value) {
                    ngModel.$validate();
                }
            });
        }
    };
};


// WEBPACK FOOTER //
// ./src/app/common/components/timepicker/time-lesser.directive.js